// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZinZ","footer":"styles_footer__1dTFb"};